import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import { Grid } from "@mui/material";
import React from "react";
import UserMenu from "./UserMenu/UserMenu";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core";
import TasksPanel from "../Tasks/components/TaskPanel/TasksPanel";
import { selectIsSeamless, selectIsLoggedIn } from "../user/userSlice";
import Typography from "@material-ui/core/Typography";
import { AppContext } from "../../App";
import { useContext } from "react";

export const useStyles = makeStyles((theme) => ({
    link: {
        textDecoration: 'none',
        color: theme.palette.primary.main,
        fontWeight: '400'
    },
    iconButton: {
        position: "absolute",
        left: 100,
        fill: "white"
    },
    iconButton2: {
        position: "absolute",
        left: 260,
        fill: "white"
    },
    logos: {
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "row"
    },
    logoContainer: {
        display: "flex",
        background: "#FFF",
        padding: "0 24px",
        alignItems: "center"
    },
    parqLogo: {
        maxWidth: "60px",
    },
    pmfLogo: {
        maxWidth: "214px"
    },
}));


const Header = () => {
    const classes = useStyles();
    const isSeamless = useSelector(selectIsSeamless);
    const { pageTitle } = useContext(AppContext);
    const isUserLoaded = useSelector(selectIsLoggedIn);

    return (
        <AppBar color="secondary">
            {
                isSeamless &&
                <div className={classes.logos}>
                    <div className={classes.logoContainer}>
                        <img
                            src="/images/ParqAIlogo.png"
                            className={classes.parqLogo}
                            alt="parq.ai"
                        />
                    </div>
                    <div className={classes.logoContainer}>
                        <img
                            src="/images/parkmyfleetLogo.png"
                            className={classes.pmfLogo}
                            alt="parkmyfleet"
                        />
                    </div>
                </div>
            }
            {
                !isSeamless &&
                <Toolbar style={{ justifyContent: "space-between" }}>
                    <Typography variant="h6" style={{ paddingLeft: "120px", color: "white", fontWeight: 500, width: "100%" }}>
                        {pageTitle}
                    </Typography>
                    {
                        isUserLoaded &&
                        <Grid container justifyContent="flex-end">
                            <TasksPanel />
                            {/* <Authorize profile={permissionProfiles.MECHANICALS_TASKS.TASK_LIST}>
                                <MechanicalTasksPanel />
                            </Authorize> */}
                            <UserMenu />

                        </Grid>
                    }
                </Toolbar>
            }
        </AppBar>
    );
};

export default Header;
